<template>
    <v-container fluid fill-height grid-list-xs pa-0 :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-layout row wrap>
            <v-flex d-flex xs12 pa-0>
                <v-card class="fill-height flex-card">
                    <v-breadcrumbs :items="breadCrumbs" class="dense">
                        <template v-slot:divider>
                            <v-icon>forward</v-icon>
                        </template>
                    </v-breadcrumbs>
                    <!--
                    <v-card-title><h2>{{ $t("equipmentProfiles") }}</h2></v-card-title>
                    -->

                    <v-toolbar card prominent dense>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="loadProfiles"
                                >
                                    <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("reload") }}</span>
                        </v-tooltip>
                        <v-menu bottom offset-y>
                            <template #activator="{ on: menu }">
                                <v-tooltip
                                    bottom
                                    :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >
                                    <template #activator="{ on: tooltip }">
                                        <v-btn
                                        flat
                                        v-on="{ ...tooltip, ...menu }"
                                        :disabled="!acl.Create || line.length != 0"
                                        >
                                            <v-icon>mdi-plus-circle-outline</v-icon>
                                            <span
                                                v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                            >{{ $t("addLineTemplate") }}</span>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("addLineTemplate") }}</span>
                                </v-tooltip>
                            </template>
                            <v-list>
                                <v-list-tile
                                v-for="(item, index) in lineTemplates"
                                :key="index"
                                @click="addLineTemplate(item.value)"
                                >
                                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    v-if="profiles.length-1 < profilesLimit || (profile !== null && profile !==undefined && profile.id > 0)"
                                    :disabled="!acl.Modify"
                                    @click="saveProfileClick"
                                >
                                    <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("save") }}</span>
                        </v-tooltip>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    v-if="profiles.length-1 >= profilesLimit && (profile !== null && profile !==undefined && profile.id == 0)"
                                    :disabled="!acl.Modify"
                                    @click="blockedSaveClick"
                                >
                                    <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("save") }}</span>
                        </v-tooltip>
                        <!-- <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    v-if="profiles.length-1 < profilesLimit"
                                    :disabled="(profile !== null && profile !==undefined && profile.id==0) || !acl.Modify"
                                    @click="saveProfileAsClick"
                                >
                                    <v-icon>mdi-content-save-edit-outline</v-icon> {{ $t("saveAs") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("saveAs") }}</span>
                        </v-tooltip>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    v-if="profiles.length-1 >= profilesLimit"
                                    :disabled="!acl.Modify"
                                    @click="blockedSaveClick"
                                >
                                    <v-icon>mdi-content-save-edit-outline</v-icon> {{ $t("saveAs") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("saveAs") }}</span>
                        </v-tooltip> -->
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="renameProfileClick"
                                    :disabled="(profile !== null && profile !== undefined && profile.id !== undefined && profile.id==0) || !acl.Delete"
                                >
                                    <v-icon>mdi-pencil-outline</v-icon> {{ $t("rename") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("rename") }}</span>
                        </v-tooltip>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="deleteProfileClick"
                                    :disabled="(profile !== null && profile !== undefined && profile.id !== undefined && profile.id==0) || !acl.Delete"
                                >
                                    <v-icon>mdi-delete-outline</v-icon> {{ $t("delete") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("delete") }}</span>
                        </v-tooltip>
                        <template v-slot:extension>
                            <v-tabs
                                v-model="tab"
                                color="transparent"
                                show-arrows
                                align-with-title
                                centered
                                dense
                            >
                                <v-tabs-slider></v-tabs-slider>

                                <v-tab v-for="(item, index) in profiles" :key="index">
                                    {{ item ? item.name : "-" }}
                                </v-tab>
                            </v-tabs>
                        </template>
                    </v-toolbar>

                    <v-card-text class="fill-height pa-0">
                        <v-container fluid fill-height grid-list-xs pa-0>
                            <v-layout row wrap>
                                <v-flex
                                    xs2 column grey
                                    class="v-scrollable"
                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                >
                                    <v-layout column wrap>
                                    <div class="ma-2">
                                        <h3>{{ $t("equipment") }}</h3>
                                    </div>
                                    <draggable
                                        :list="equipment"
                                        :group="{ name: 'equipment', pull: 'clone', put: true }"
                                        class="dragArea content-centered row wrap"
                                        :clone="cloneEquipment"
                                        @change="equipmentEvent"
                                        :disabled="isLiveCutScheme"
                                    >
                                        <div
                                            icon
                                            v-for="(item, index) in equipment"
                                            :key="index"
                                            :title="`${$t(item.name)}`"
                                            class="equipment-item-small"
                                        >
                                            <img :src="item.image">
                                            <div class="item-title">{{ $t(item.shortName) }}</div>
                                        </div>
                                    </draggable>
                                    <div v-if="$i18n.locale == 'ru'" class="ml-2 text--secondary">
                                        <p>
                                            Для добавления / удаления оборудования используйте Drag&Drop.
                                            Подробное описание оборудования можно найти в разделе "Справка" (верхний правый угол).
                                        </p>
                                    </div>
                                    <div v-else class="ml-2 text--secondary">
                                        <p>
                                            Use Drag&Drop to add/remove equipment.
                                            A detailed description of the equipment can be found in the "Help" section (upper right corner).
                                        </p>
                                    </div>
                                    </v-layout>
                                </v-flex>
                                <v-flex
                                    xs10 d-flex elevation-0
                                >
                                    <v-layout flex-child wrap>
                                        <v-flex xs12 class="row-v line-card">
                                            <div class="ma-2">
                                                <h3>
                                                    {{ `${$t("line")} ${tab && tab != 0 && profile && profile.name ? profile.name : ''}` }}
                                                    <span
                                                        :title="`${$t('lineChangedHint')}`"
                                                        class="red--text unsaved"
                                                        v-if="lineChanged"
                                                    >
                                                        <v-icon class="mx-2 red--text">mdi-lightbulb-on</v-icon>{{ $t("lineChanged")}}
                                                    </span>
                                                </h3>
                                            </div>

                                            <span
                                                v-if="isLiveCutScheme"
                                            >
                                                <v-icon class="ml-2">mdi-alert</v-icon>{{ $t("notes.liveCutLine") }}
                                            </span>

                                            <draggable
                                                :list="line"
                                                :group="{ name: 'equipment', put: true }"
                                                class="dragArea row wrap justify-space-around line"
                                                @change="lineEvt"
                                                @add="addToLineEvt"
                                            >
                                                <div
                                                    v-for="(item, index) in line"
                                                    :key="index"
                                                    class="equipment-item blockHead"
                                                    :class="{ selected: index == selectedIndex }"
                                                    @click="selectEquipment(item, index)"
                                                >
                                                    <v-avatar class="dev-num" size="24" color="primary" text-color="white">{{ index + 1 }}</v-avatar>
                                                    <v-avatar v-if="!$obj.isEmpty(item.data)" class="dev-settings" size="24" color="primary" text-color="white"><v-icon>mdi-cog</v-icon></v-avatar>
                                                    <v-hover>
                                                        <v-card
                                                            slot-scope="{ hover }"
                                                            class="mx-auto"
                                                            color="grey lighten-4"
                                                            max-width="600"
                                                        >
                                                            <v-img
                                                                :aspect-ratio="1/1"
                                                                :src="item.image"
                                                            >
                                                                <v-expand-transition>
                                                                    <div
                                                                        v-if="hover"
                                                                        class="d-flex transition-fast-in-fast-out blue darken-2 v-card--reveal white--text item-title"
                                                                        style="height: 100%;"
                                                                    >
                                                                        {{ $t(item.name) }}
                                                                    </div>
                                                                </v-expand-transition>
                                                            </v-img>
                                                            <div class="item-title" v-if="false">{{ $t(item.name) }}</div>
                                                        </v-card>
                                                    </v-hover>
                                                </div>
                                            </draggable>
                                            <div style="clear: both;"/>
                                        </v-flex>
                                        <v-flex xs6 md7 lg8 xl9 class="row-v" elevation-0>
                                            <v-divider></v-divider>
                                            <band-saw-settings       ref="BandSawSettings"/>
                                            <circular-saw-settings   ref="CircularSawSettings"/>
                                            <edge-trimmer-settings   ref="EdgeTrimmerSettings"/>
                                            <FBSSettings             ref="FBSSettings"/>
                                            <multi-saw-settings      ref="MultiSawSettings"/>
                                            <profiling-settings      ref="ProfilingSettings"/>
                                            <horizontal-saw-settings ref="HorizontalSawSettings"/>
                                        </v-flex>
                                        <v-flex xs6 md5 lg4 xl3 class="row-v" elevation-0>
                                            <v-divider></v-divider>

                                            <div class="mx-2 my-4">
                                                <h3>{{ $t("patternSample") }}</h3>
                                            </div>

                                            <v-sheet>
                                                    <pattern-vue
                                                        :pattern="pattern"
                                                        :sizeNominal="1"
                                                        :falseCore="0"
                                                        :ellipseRatio="0"
                                                        :rotate="0"
                                                        :showDiameter="false"
                                                        :patternSolidBG="patternSolidBG"
                                                        :rotatePattern="rotatePattern"
                                                        sideSize="220"
                                                        ref="PatternVue"
                                                        class="no-text-info"
                                                    />
                                            </v-sheet>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>

            <list-select-dialog ref="ListSelectDialog"/>
            <message-box        ref="MessageBox"/>
            <message-dialog     ref="MessageDialog"/>
            <text-input-dialog  ref="TextInputDialog"/>
        </v-layout>
    </v-container>
</template>

<script>
    import Draggable           from "vuedraggable";

    import BandSawSettings       from "@/components/equipment/BandSawSettings";
    import CircularSawSettings   from "@/components/equipment/CircularSawSettings";
    import EdgeTrimmerSettings   from "@/components/equipment/EdgeTrimmerSettings";
    import FBSSettings           from "@/components/equipment/FBSSettings";
    import ListSelectDialog      from "@/components/dialogs/ListSelectDialog";
    import MessageBox            from "@/components/dialogs/MessageBox";
    import MessageDialog         from "@/components/dialogs/MessageDialog";
    import MultiSawSettings      from "@/components/equipment/MultiSawSettings";
    import PatternVue            from "@/components/patterns/PatternVue";
    import ProfilingSettings     from "@/components/equipment/ProfilingSettings";
    import HorizontalSawSettings from "@/components/equipment/HorizontalSawSettings";
    import TextInputDialog       from "@/components/dialogs/TextInputDialog";

    export default {
        name: "EquipmentProfiles",

        inject: ["theme"],

        components: {
            Draggable,
            BandSawSettings,
            CircularSawSettings,
            EdgeTrimmerSettings,
            FBSSettings,
            ListSelectDialog,
            MessageBox,
            MessageDialog,
            MultiSawSettings,
            PatternVue,
            ProfilingSettings,
            HorizontalSawSettings,
            TextInputDialog
        },

        data () {
            return {
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Справочники",          disabled: false },
                    { text: "Профили оборудования", disabled: false }
                ],
                alert: "",
                alertType: "success",
                dialogWatcher: null,
                equipment: [],
                equipmentId: 0,
                equipmentSrc: [],
                line: [],
                lineChanged: false,
                loading: {
                    equipment: false,
                    profiles:  false
                },
                lineTemplates: [
                    //{ text: "Брус", value: "cant" },
                    { text: "Развал", value: "liveCut" },
                    { text: "Рама-многопил", value: "multiSawsFrame" },
                    { text: "Фрезерно-профилирующая", value: "profilingLine" },
                    { text: "Фрезерно-брусующая", value: "chipperCanter" },
                    { text: "Скандинавская схема", value: "scandinavian" },
                    //{ text: "Кручением", value: "torsion" },
                    { text: "Ленточная c многопилом", value: "bandLineWithMulti" },
                    { text: "Ленточная c поворотом", value: "bandLineWithRotate" }
                ],
                isLiveCutScheme: false,
                isRenameRequest: false,
                pattern: {},
                profile: null,
                profileId: null,
                profiles: [],
                profilesLimit: 1,
                selectedIndex: null,
                tab: null,
                equipmentVisible: false,
                rotatePattern: false,
                patternSolidBG: false
            }
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.equipment || this.loading.profiles;
            }
        },

        beforeRouteLeave (to, from , next) {
            if (this.lineChanged) {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("attention");
                this.$refs.MessageDialog.messageText = this.$t("confirmUnsaved");
                this.$refs.MessageDialog.dialog      = true;
            } else {
                next();
            }
        },

        async mounted() {
            this.applyLocale();

            this.tab = localStorage.equipmentTab ? parseInt(localStorage.equipmentTab) : 0;

            this.loadProfiles();
            this.loadEquipment();


            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "equipment") {
                        this.acl = aclRecord;
                    }
                });
            }

            let user = this.$store.getters.user;
            this.patternSolidBG = user.settings.patternSolidBG;
            this.rotatePattern  = user.settings.rotatePattern;

            this.profilesLimit = this.$store.getters.subscription.limits.maxLines
                ? this.$store.getters.subscription.limits.maxLines
                : 1;



            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.$watch(
                "$refs.TextInputDialog.answer",
                (val) => {
                    if (val) {
                        if (this.$refs.TextInputDialog.textInput.trim() == "") {
                            this.$refs.MessageBox.title       = this.$t("error");
                            this.$refs.MessageBox.messageText = this.$t("profileNameCantBeEmpty");
                            this.$refs.MessageBox.dialog      = true;
                        } else {
                            if (this.isRenameRequest) {
                                this.renameProfile(this.$refs.TextInputDialog.textInput);
                            } else {
                                this.saveProfileAs(this.$refs.TextInputDialog.textInput);
                            }
                        }
                    }
                }
            );

            /* Отслеживание изменений настроек кромкообрезного станка */
            this.$watch(
                "$refs.EdgeTrimmerSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.maxAmount.val = parseInt(this.$refs.EdgeTrimmerSettings.maxAmount.val);
                            data.kerf.val      = parseFloat(this.$refs.EdgeTrimmerSettings.kerf.val);
                            data.optimizationByWidth.val = this.$refs.EdgeTrimmerSettings.optimizeByWidth ? 1 : 0;
                            data.sameWidth     = this.$refs.EdgeTrimmerSettings.sameWidth ? 1 : 0;

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.EdgeTrimmerSettings.changed = false;
                    }
                }
            );

            /* Отслеживание выбора в списке профилей*/
            this.$watch(
                "$refs.ListSelectDialog.answer",
                (val) => {
                    if (val) {
                        this.profiles.forEach((item) => {
                            if (item.id == this.$refs.ListSelectDialog.selected.id) {
                                this.profileId = item.id;
                            }
                        });
                    }
                }
            );

            /* Отслеживание изменений настроек ленточной пилы */
            this.$watch(
                "$refs.BandSawSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.kerf.val = parseFloat(this.$refs.BandSawSettings.kerf.val);
                            data.trimSideBoards.val = this.$refs.BandSawSettings.trimSideBoards ? 1 : 0;
                            data.sideBoardsMax.val = parseInt(this.$refs.BandSawSettings.maxSideBoardsAmount.val);
                            data.splitSides.val = this.$refs.BandSawSettings.splitSides ? 1 : 0;
                            data.trimCentralPattern.val = this.$refs.BandSawSettings.trimCentralPattern ? 1 : 0;
                            data.splitCentral.val = this.$refs.BandSawSettings.splitCentral ? 1 : 0;

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.BandSawSettings.changed = false;
                        this.createExamplePattern();
                    }
                }
            );

            /* Отслеживание изменений настроек круглопильного станка */
            this.$watch(
                "$refs.CircularSawSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.maxAmount.val = parseInt(this.$refs.CircularSawSettings.maxAmount.val);
                            data.kerf.val      = parseFloat(this.$refs.CircularSawSettings.kerf.val);
                            data.kerfExt.val   = parseFloat(this.$refs.CircularSawSettings.kerfExt.val);
                            data.halfCantEnabled.val = this.$refs.CircularSawSettings.halfCantEnabled ? 1 : 0;
                            data.halfCant.val  =  parseFloat(this.$refs.CircularSawSettings.halfCant.val);
                            data.sawsThicknessByKerfHeight.val = this.$refs.CircularSawSettings.thicknessByKerf ? 1 : 0;
                            data.similarSizeBoards.val = this.$refs.CircularSawSettings.similarSizeBoards ? 1 : 0;
                            data.useEdgeTrimmer.val = this.$refs.CircularSawSettings.useEdgeTrimmer ? 1 : 0;
                            data.edgeTrimmerMaxAmount.val   = parseInt(this.$refs.CircularSawSettings.edgeTrimmerMaxAmount.val);
                            data.edgeTrimmerKerf.val        = parseFloat(this.$refs.CircularSawSettings.edgeTrimmerKerf.val);
                            data.useCleanSaws.val = this.$refs.CircularSawSettings.useCleanSaws ? 1 : 0;
                            data.cleanKerf.val = parseFloat(this.$refs.CircularSawSettings.cleanKerf.val);

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.CircularSawSettings.changed = false;
                        this.createExamplePattern();
                    }
                }
            );

            /* Отслеживание изменений настроек ФБС */
            this.$watch(
                "$refs.FBSSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.maxCantThickness.val      = parseInt(this.$refs.FBSSettings.maxCantThickness.val);
                            data.maxCuttingDepth.val       = parseFloat(this.$refs.FBSSettings.maxCuttingDepth.val);
                            data.minTopSideBoardsWidth.val = parseInt(this.$refs.FBSSettings.minTopSideBoardsWidth.val);
                            data.useCleanSaws.val = this.$refs.FBSSettings.useCleanSaws ? 1 : 0;
                            data.cleanKerf.val = parseFloat(this.$refs.FBSSettings.cleanKerf.val);

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.FBSSettings.changed = false;
                    }
                }
            );

            /* Отслеживание изменений настроек многопила */
            this.$watch(
                "$refs.MultiSawSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.maxAmount.val   = parseInt(this.$refs.MultiSawSettings.maxAmount.val);
                            data.kerf.val        = parseFloat(this.$refs.MultiSawSettings.kerf.val);
                            data.patternType.val = this.$refs.MultiSawSettings.patternType;
                            data.sawWidthDependOnKerf.val = this.$refs.MultiSawSettings.sawWidthDep ? 1 : 0;
                            data.useEdgeTrimmer.val = this.$refs.MultiSawSettings.useEdgeTrimmer ? 1 : 0;
                            data.splitCentralBoards.val = this.$refs.MultiSawSettings.splitCentralBoards ? 1 : 0;
                            data.edgeTrimmerMaxAmount.val   = parseInt(this.$refs.MultiSawSettings.edgeTrimmerMaxAmount.val);
                            data.edgeTrimmerKerf.val        = parseFloat(this.$refs.MultiSawSettings.edgeTrimmerKerf.val);
                            data.useCleanSaws.val = this.$refs.MultiSawSettings.useCleanSaws ? 1 : 0;
                            data.cleanKerf.val = parseFloat(this.$refs.MultiSawSettings.cleanKerf.val);

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.MultiSawSettings.changed = false;
                        this.createExamplePattern();
                    }
                }
            );

            /* Отслеживание изменений настроек профилирующего станка */
            this.$watch(
                "$refs.ProfilingSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.maxProfilingDepth.val = parseInt(this.$refs.ProfilingSettings.maxDepth.val);
                            data.sideBoardsMax.val     = parseInt(this.$refs.ProfilingSettings.maxSideBoardsAmount.val);
                            data.centralBoardsThicknessMin.val = parseInt(this.$refs.ProfilingSettings.centralBoardsMinTotalThickness.val);
                            data.useCleanSaws.val = this.$refs.ProfilingSettings.useCleanSaws ? 1 : 0;
                            data.cleanKerf.val = parseFloat(this.$refs.ProfilingSettings.cleanKerf.val);

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.ProfilingSettings.changed = false;
                        this.createExamplePattern();
                    }
                }
            );

            /* Отслеживание изменений настроек горизонтальной пилы */
            this.$watch(
                "$refs.HorizontalSawSettings.changed",
                (val) => {
                    if (val) {
                        if (this.line[this.selectedIndex].data !== null) {
                            let data = this.line[this.selectedIndex].data;

                            data.maxAmount.val = parseInt(this.$refs.HorizontalSawSettings.maxAmount.val);
                            data.kerf.val      = parseFloat(this.$refs.HorizontalSawSettings.kerf.val);

                            this.line[this.selectedIndex].data = data;
                            this.lineChanged = true;
                        }

                        this.$refs.HorizontalSawSettings.changed = false;
                        this.createExamplePattern();
                    }
                }
            );
        },

        watch: {
            alert: function (val) {
                let component = this;

                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            lineChanged: function (val) {
                if (val) { this.saveProfileLocal(); }
            },

            profileId: function (val) {
                this.profiles.forEach((item) => {
                    if (item.id == val) { this.profile = item; }
                })
            },

            //selectedIndex: function (newVal, oldVal) {
                /*
                this.$debug.log("selectedIndex old = " + oldVal);
                this.$debug.log("selectedIndex new = " + newVal);
                */
            //},

            tab: function (val) {
                this.hideSettings();

                localStorage.equipmentTab = val;

                if (!localStorage.getItem("line" + this.tab)) {
                    this.loadProfile();
                } else {
                    this.line = JSON.parse(localStorage.getItem("line" + this.tab));
                    this.lineChanged = true;
                }
                this.selectedIndex = null;

                if (val == 0)
                    this.isLiveCutScheme = false;
                else
                    this.isLiveCutScheme = (this.line[1] !== undefined
                                            && this.line[1].data !== null
                                            && this.line[1].data.isLiveCutScheme !== undefined
                                            && this.line[1].data.isLiveCutScheme.val == 1) ? true : false;
            },

            line: function () {
                this.createExamplePattern();
                this.isLiveCutScheme = (this.line[1] !== undefined
                                        && this.line[1].data !== null
                                        && this.line[1].data.isLiveCutScheme !== undefined
                                        && this.line[1].data.isLiveCutScheme.val == 1) ? true : false;
            }
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("catalogs"),          disabled: false },
                    { text: this.$t("equipmentProfiles"), disabled: false }
                ];

                this.lineTemplates = [
                    //{ text: this.$t("lineTemplates.cant"), value: "cant" },
                    { text: this.$t("lineTemplates.liveCut"), value: "liveCut" },
                    { text: this.$t("lineTemplates.multiSawsFrame"), value: "multiSawsFrame" },
                    { text: this.$t("lineTemplates.profilingLine"), value: "profilingLine" },
                    { text: this.$t("lineTemplates.chipperCanter"), value: "chipperCanter" },
                    { text: this.$t("lineTemplates.scandinavian"), value: "scandinavian" },
                    //{ text: this.$t("lineTemplates.torsion"), value: "torsion" },
                    { text: this.$t("lineTemplates.bandLineWithMulti"), value: "bandLineWithMulti" },
                    { text: this.$t("lineTemplates.bandLineWithRotate"), value: "bandLineWithRotate" },
                ];
            },

            /**
             * Добавление шаблона лесопильной линии
             *
             * @param {string} lineTemplate    Название шаблона
             */
            addLineTemplate (lineTemplate) {
                this.lineChanged = true;

                switch (lineTemplate) {
                    case "liveCut":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 6)[0])));
                        this.line[1].data.isLiveCutScheme.val = 1;
                        this.line[1].data.useEdgeTrimmer.val = 1;
                        this.line[1].data.splitCentralBoards.val = 1;
                        this.line[1].data.edgeTrimmerMaxAmount.val = 3;
                        this.isLiveCutScheme = true;
                        break;
                    case "multiSawsFrame":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 5)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 6)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 9)[0])));
                        this.line[2].data.useEdgeTrimmer.val = 0;
                        break;
                    case "profilingLine":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 3)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 3)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 4)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 5)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 4)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 6)[0])));
                        break;
                    case "chipperCanter":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 3)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 6)[0])));
                        break;
                    case "scandinavian":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 3)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 5)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 3)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 4)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 6)[0])));
                        this.line[1].data.maxAmount.val = 3;
                        break;
                    case "!torsion!":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 8)[0])));
                        break;
                    case "bandLineWithMulti":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 8)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 6)[0])));
                        this.line[2].data.useEdgeTrimmer.val = 1;
                        this.line[2].data.edgeTrimmerMaxAmount.val = 2;
                        break;
                    case "bandLineWithRotate":
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 8)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 2)[0])));
                        this.line.push(JSON.parse(JSON.stringify(this.equipment.filter(line => line.id == 8)[0])));
                        this.line[0].data.splitSides.val = 1;
                        this.line[0].data.sideBoardsMax.val = 2;
                        this.line[2].data.splitSides.val = 1;
                        this.line[2].data.sideBoardsMax.val = 2;
                        this.line[2].data.trimCentralPattern.val = 1;
                        this.line[2].data.splitCentral.val = 1;
                        break;
                }
            },

            /**
             * Обработчик нажатия кнопки сохранения при превышенном лимите сохранений
             */
            blockedSaveClick () {
                if (this.profiles.length >= this.profilesLimit) {
                    this.showMessageBox(this.$t("attention"), this.$t("saveProfilesLimitReachedMessage"));
                }
            },

            /**
             * Создание пустой структуры с образцом раскроя
             */
            createEmptyPattern () {
                let emptyPattern = {
                        du:        26,
                        kerf:      5,
                        order:     1,
                        v:         2,
                        vertical:  0,
                        items: [
                            {
                                order:    2,
                                vertical: 1,
                                items: [
                                    {
                                        order:    0,
                                        vertical: 1,
                                        items: []
                                    },
                                ]
                            },
                        ]
                    };

                this.pattern = { ...emptyPattern };
            },

            /**
             * Проверка наличия круглопила или многопила после переданного оборудования
             *
             * @param {number} index    Идентификатор начального объекта
             *
             * @returns {bool}  true - circule, false - multisaw
             */
            checkNextSawEquipment (index) {
                for (let i=index; i < this.line.length; i++){
                    if (this.line[i].id == 5) {
                        return true;
                    }
                    if (this.line[i].id == 6) {
                        return false;
                    }
                }
            },

            /**
             * Формирование образца раскроя исходя из состава линии
             */
            createExamplePattern () {
                this.createEmptyPattern();

                let exampleParameters = {
                    centralPattern: {
                        maxAmount:      0,
                        patternType:    0,      // 1-even, 2-odd, 3-sim, 4-asim
                        splitsAmount:   1,
                        splitCentral:   false,
                        splitsCentralAmount: 1,
                        halfCant:       false,
                        sideBoards:     0,
                        maxSideBoards:  2
                    },
                    sidePattern: {
                        maxAmount:      0,
                        splitsAmount:   1,
                        maxSideBoards:  3,
                        centralThick:   0,
                        similarBoards:  false
                    }
                }

                let component = this;
                let fbsIsUsed = 0;
                let circularSawAmount = 0;
                let thereIsSawEquipmentSide = false;
                let thereIsSawEquipmentCentral = false;
                let fbsCentralAdded = false;
                let bufBoards = 0;
                this.line.forEach((equipment, index) => {
                    switch (equipment.id) {
                        //fbs
                        case 3:
                            fbsIsUsed++;
                            if (fbsIsUsed == 1 && !this.checkNextSawEquipment(index)) {
                                exampleParameters.centralPattern.maxAmount += 2;
                                fbsCentralAdded = true;
                            } else if (fbsIsUsed == 1) {
                                exampleParameters.sidePattern.maxAmount += 1;

                            } else if (fbsIsUsed == 2 && !fbsCentralAdded) {
                                exampleParameters.centralPattern.maxAmount += 2;
                            }
                            break;
                        //profilingMachine
                        case 4:
                            if (this.checkNextSawEquipment(index)) {
                                exampleParameters.sidePattern.maxSideBoards = component.line[index].data.sideBoardsMax.val;
                            } else {
                                exampleParameters.centralPattern.maxSideBoards = component.line[index].data.sideBoardsMax.val;
                                exampleParameters.centralPattern.sideBoards = component.line[index].data.sideBoardsMax.val > 2
                                                                            ? 2
                                                                            : component.line[index].data.sideBoardsMax.val;
                            }
                            break;
                        //circularSaw
                        case 5:
                            thereIsSawEquipmentSide = true;
                            circularSawAmount++;
                            if (circularSawAmount == 1) {
                                bufBoards = exampleParameters.sidePattern.maxAmount;

                                if (component.line[index].data.maxAmount.val > 1) {
                                    exampleParameters.sidePattern.maxAmount += Math.floor((component.line[index].data.maxAmount.val - 2) / 2);
                                } else {
                                    exampleParameters.sidePattern.maxAmount = 0;
                                }

                                if (component.line[index].data.useEdgeTrimmer.val) {
                                    exampleParameters.sidePattern.splitsAmount = component.line[index].data.edgeTrimmerMaxAmount.val - 1;
                                }

                                if (component.line[index].data.halfCantEnabled.val) {
                                    exampleParameters.centralPattern.halfCant = true;
                                    exampleParameters.sidePattern.maxAmount = bufBoards;
                                    exampleParameters.sidePattern.maxAmount += (component.line[index].data.maxAmount.val - 2) / 2;
                                    exampleParameters.sidePattern.maxAmount--;
                                }

                                exampleParameters.sidePattern.maxAmount = (exampleParameters.sidePattern.maxAmount > exampleParameters.sidePattern.maxSideBoards)
                                    ? exampleParameters.sidePattern.maxSideBoards
                                    : exampleParameters.sidePattern.maxAmount;

                                exampleParameters.sidePattern.maxAmount = exampleParameters.sidePattern.maxAmount > 2
                                    ? 2
                                    : exampleParameters.sidePattern.maxAmount;

                                exampleParameters.sidePattern.similarBoards = component.line[index].data.similarSizeBoards.val;
                            }

                            if (circularSawAmount == 2) {
                                bufBoards = exampleParameters.centralPattern.sideBoards;

                                if (component.line[index].data.maxAmount.val > 1) {
                                    exampleParameters.centralPattern.sideBoards += Math.floor((component.line[index].data.maxAmount.val - 2) / 2);
                                } else {
                                    exampleParameters.centralPattern.sideBoards = 0;
                                }

                                if (component.line[index].data.useEdgeTrimmer.val) {
                                    exampleParameters.centralPattern.splitsAmount = component.line[index].data.edgeTrimmerMaxAmount.val - 1;
                                }

                                exampleParameters.centralPattern.sideBoards = (exampleParameters.centralPattern.sideBoards > exampleParameters.centralPattern.maxSideBoards)
                                    ? exampleParameters.centralPattern.maxSideBoards
                                    : exampleParameters.centralPattern.sideBoards;

                                exampleParameters.centralPattern.sideBoards = exampleParameters.centralPattern.sideBoards > 2
                                    ? 2
                                    : exampleParameters.centralPattern.sideBoards;
                            }

                            break;
                        //multiSaw
                        case 6:
                            if (thereIsSawEquipmentCentral) {
                                exampleParameters.centralPattern.maxAmount = 0;
                                exampleParameters.centralPattern.sideBoards = 0;
                                exampleParameters.centralPattern.patternType = 0;
                                exampleParameters.centralPattern.splitsAmount = 1;
                                exampleParameters.centralPattern.splitsCentralAmount = 1;
                                exampleParameters.centralPattern.splitCentral = false;
                            } else {
                                thereIsSawEquipmentCentral = true;
                            }

                            if (component.line[index].data.maxAmount.val > 0) {
                                exampleParameters.centralPattern.maxAmount += component.line[index].data.maxAmount.val - 1;
                            } else {
                               exampleParameters.centralPattern.maxAmount = 0;
                            }
                            exampleParameters.centralPattern.patternType = component.line[index].data.patternType.val;

                            if (component.line[index].data.useEdgeTrimmer.val && circularSawAmount < 2) {
                                exampleParameters.centralPattern.splitsAmount = component.line[index].data.edgeTrimmerMaxAmount.val - 1;
                                exampleParameters.centralPattern.splitCentral = component.line[index].data.splitCentralBoards.val;
                                if (exampleParameters.centralPattern.maxAmount > 2) {
                                    exampleParameters.centralPattern.sideBoards =  exampleParameters.centralPattern.maxAmount > 10 ? 2 : 1;
                                    exampleParameters.centralPattern.sideBoards = (exampleParameters.centralPattern.sideBoards > exampleParameters.centralPattern.maxSideBoards)
                                        ? exampleParameters.centralPattern.maxSideBoards
                                        : exampleParameters.centralPattern.sideBoards;
                                }

                                if (exampleParameters.centralPattern.splitCentral) {
                                    exampleParameters.centralPattern.splitsCentralAmount = component.line[index].data.edgeTrimmerMaxAmount.val - 1;
                                }
                            }

                            if (exampleParameters.centralPattern.halfCant) {
                                exampleParameters.centralPattern.splitsAmount = 2;
                                exampleParameters.centralPattern.splitsCentralAmount = 2;
                                exampleParameters.centralPattern.splitCentral = true;
                            }

                            break;
                        //bandSaw
                        case 8:
                            if (component.line[index].data.trimSideBoards.val && thereIsSawEquipmentSide) {
                                exampleParameters.centralPattern.sideBoards = 2;
                            }

                            if (component.line[index].data.trimSideBoards.val && !thereIsSawEquipmentSide) {
                                exampleParameters.sidePattern.maxAmount = component.line[index].data.sideBoardsMax.val > 2 ? 2 : component.line[index].data.sideBoardsMax.val;

                                if (component.line[index].data.splitSides.val && !thereIsSawEquipmentSide) {
                                    exampleParameters.sidePattern.splitsAmount = 2;
                                }

                                thereIsSawEquipmentSide = true;
                            }

                            if (component.line[index].data.trimCentralPattern.val) {
                                exampleParameters.centralPattern.maxAmount = exampleParameters.sidePattern.maxAmount > 1 ? 12 : 10;
                                //exampleParameters.centralPattern.sideBoards = 2;
                                exampleParameters.centralPattern.patternType = 3;

                                if (component.line[index].data.splitCentral.val) {
                                    exampleParameters.centralPattern.splitsAmount = 2;
                                    exampleParameters.centralPattern.splitsCentralAmount = 2;
                                    exampleParameters.centralPattern.splitCentral = true;
                                }
                                thereIsSawEquipmentCentral = true;
                            }
                            break;
                        //horizontalSaw
                        case 9:
                            exampleParameters.centralPattern.splitsAmount = component.line[index].data.maxAmount.val > 2 ? 3 : component.line[index].data.maxAmount.val + 1;
                            exampleParameters.centralPattern.splitsCentralAmount = component.line[index].data.maxAmount.val > 2 ? 3 : component.line[index].data.maxAmount.val + 1;
                            exampleParameters.centralPattern.splitCentral = true;
                            break;
                    }
                });

                let centralTn = exampleParameters.centralPattern.maxAmount > 8 ? 15 : 25;
                let centralWn = 0;
                exampleParameters.centralPattern.maxAmount -= exampleParameters.centralPattern.sideBoards*2;
                let boards = exampleParameters.centralPattern.maxAmount + exampleParameters.centralPattern.sideBoards;

                if (boards < 6) {
                    centralWn = 125;
                } else if (boards < 10) {
                    centralWn = 150;
                } else if (boards < 15) {
                    centralWn = 175;
                } else if (boards < 17) {
                    centralWn = 200;
                } else if (boards <= 20) {
                    centralWn = 250;
                }

                exampleParameters.sidePattern.centralThick = exampleParameters.centralPattern.maxAmount > 0
                    ? centralTn * exampleParameters.centralPattern.maxAmount
                    : centralTn * 5;

                if (this.isLiveCutScheme) {
                    for (let i=0;i < exampleParameters.centralPattern.maxAmount/2;i++) {
                        let object = {
                            order:    0,
                            vertical: 0,
                            items:    []
                        };
                        let asyncObject = JSON.parse(JSON.stringify(object));

                        for (let j=1; j < exampleParameters.centralPattern.splitsCentralAmount+1; j++) {
                            let splitedW = centralWn*1.5 / exampleParameters.centralPattern.splitsCentralAmount;
                            if (exampleParameters.centralPattern.patternType == 4 && i == 0) {
                                centralTn /= 2;
                                asyncObject.items.push({tn:centralTn*2,ts:centralTn*2,vertical:0,wn:splitedW,ws:splitedW});
                                object.items.push({tn:centralTn,ts:centralTn,vertical:0,wn:splitedW,ws:splitedW});
                                centralTn *= 2;
                            } else {
                                object.items.push({tn:centralTn,ts:centralTn,vertical:0,wn:splitedW,ws:splitedW});
                            }
                        }

                        centralWn *= 0.9;

                        if (i == 0) {
                            if (exampleParameters.centralPattern.patternType == 1 && exampleParameters.centralPattern.patternType == 3) {
                                this.pattern.items[0].items[0].items.push({...object});
                                this.pattern.items[0].items[0].items.push({...object});
                            } else if (exampleParameters.centralPattern.patternType == 2) {
                                this.pattern.items[0].items[0].items.push({...object});
                            } else if (exampleParameters.centralPattern.patternType == 4) {
                                this.pattern.items[0].items[0].items.push({...asyncObject});
                                this.pattern.items[0].items[0].items.push({...object});
                            }

                            continue;
                        }

                        this.pattern.items[0].items[0].items.unshift({...object});
                        this.pattern.items[0].items[0].items.push({...object});
                    }

                    for (let i=0;i < exampleParameters.centralPattern.sideBoards;i++) {
                        let object = {
                            order:    2,
                            vertical: 0,
                            items:    []
                        };

                        if (i >= exampleParameters.centralPattern.sideBoards-1) {
                            exampleParameters.centralPattern.splitsAmount -= 1;
                        }

                        for (let j=1; j < exampleParameters.centralPattern.splitsAmount+1; j++) {
                            let splitedW = centralWn*1.5 / exampleParameters.centralPattern.splitsAmount;
                            object.items.push({tn:centralTn*0.9,ts:centralTn*0.9,vertical:0,wn:splitedW*0.9,ws:splitedW*0.9});
                        }
                        this.pattern.items[0].items.unshift({...object});
                        this.pattern.items[0].items.push({...object});
                        centralWn *= 0.9;
                    }
                    return 0;
                }

                if (exampleParameters.centralPattern.patternType == 1) {
                    if (exampleParameters.centralPattern.maxAmount % 2 != 0) {
                        exampleParameters.centralPattern.maxAmount--;
                    }
                } else if (exampleParameters.centralPattern.patternType == 2) {
                   if (exampleParameters.centralPattern.maxAmount % 2 == 0) {
                        exampleParameters.centralPattern.maxAmount--;
                    }
                }

                if (thereIsSawEquipmentCentral) {
                    for (let i=0;i < exampleParameters.centralPattern.maxAmount;i++) {
                        let object = {
                            order:    2,
                            vertical: 0,
                            items:    []
                        };

                        for (let j=1; j < exampleParameters.centralPattern.splitsCentralAmount+1; j++) {
                            let splitedW = centralWn / exampleParameters.centralPattern.splitsCentralAmount;
                            if (exampleParameters.centralPattern.patternType == 4 && i == 0) {
                                object.items.push({tn:centralTn*2,ts:centralTn*2,vertical:0,wn:splitedW,ws:splitedW});
                            } else {
                                object.items.push({tn:centralTn,ts:centralTn,vertical:0,wn:splitedW,ws:splitedW});
                            }
                        }
                        this.pattern.items[0].items[0].items.push({...object});
                    }
                }

                let w = centralWn;
                if (thereIsSawEquipmentCentral) {
                    for (let i=0;i < exampleParameters.centralPattern.sideBoards;i++) {
                        let object = {
                            order:    2,
                            vertical: 0,
                            items:    []
                        };
                        for (let j=1; j < exampleParameters.centralPattern.splitsAmount+1; j++) {
                            let splitedW = w / exampleParameters.centralPattern.splitsAmount;
                            object.items.push({tn:centralTn*0.9,ts:centralTn*0.9,vertical:0,wn:splitedW*0.75,ws:splitedW*0.75});
                        }
                        this.pattern.items[0].items.unshift({...object});
                        this.pattern.items[0].items.push({...object});
                        w /= 2;
                    }
                }

                w = exampleParameters.sidePattern.centralThick;
                let t = exampleParameters.centralPattern.maxAmount > 8 ? 20 : 15;
                if (thereIsSawEquipmentSide) {
                    for (let i=0;i < exampleParameters.sidePattern.maxAmount;i++) {
                        let object = {
                            order:    2,
                            vertical: 1,
                            items:    []
                        };
                        for (let j=1; j < exampleParameters.sidePattern.splitsAmount+1; j++) {
                            let splitedW = w / exampleParameters.sidePattern.splitsAmount;
                            object.items.push({tn:t,ts:t,vertical:1,wn:splitedW*0.75,ws:splitedW*0.75});
                        }
                        this.pattern.items.unshift({...object});
                        this.pattern.items.push({...object});

                        if (!exampleParameters.sidePattern.similarBoards) {
                            w /= 2;
                        }
                    }
                }

                if (!thereIsSawEquipmentSide && !thereIsSawEquipmentCentral && fbsIsUsed >= 2) {
                   this.pattern.items[0].items[0].items.push({tn:200,ts:200,vertical:1,wn:200,ws:200});
                }
            },

            /**
             * Клонирование объекта оборудования
             *
             * @param {number} id    Идентификатор нового объекта
             * @param {string} name  Имя объекта
             * @param {string} image Пиктограмма
             * @param {object} data  Шаблонный объект
             */
            cloneEquipment ({ id, name, image, data }) {
                return {
                    id:    id, //this.equipmentId++,
                    //uid: this.equipmentId++,
                    name:  name,
                    image: image,
                    data:  JSON.parse(JSON.stringify(data))
                };
            },

            /**
             * Удаление текущего профиля
             */
            deleteProfile () {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}lines/${this.profile.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.alertType = "success";
                    this.alert     = this.$t("profileDeleted");

                    this.loadProfiles();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteProfile") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteProfile") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteProfile"));
                    }
                });
            },

            renameProfile (profileName) {
                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}lines/name/${this.profile.id}/`,
                    data: {
                        name: profileName,
                    },
                    withCredentials: true
                }).then(() => {
                    this.alertType   = "success";
                    this.alert       = this.$t("profileSaved");
                    this.dataUpdated = true;
                    this.lineChanged = false;

                    this.deleteProfileLocal();
                    this.loadProfiles();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки переименования профиля
             */
            renameProfileClick () {
                this.isRenameRequest = true;
                this.saveProfileAsClick();
            },

            /**
             * Обработчик нажатия кнопки удаления профиля
             */
            deleteProfileClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteProfile(); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("deleteProfile"); // + " \"" + this.profile.name + "\"";
                this.$refs.MessageDialog.messageText = this.$t("confirmProfileDelete") + " (" + this.profile.name + ")";
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Удаление текущего профиля из localStorage
             */
            deleteProfileLocal () { localStorage.removeItem("line" + this.tab); },

            /**
             * Отслеживание перетаскивания на панель оборудования
             */
            equipmentEvent (evt) {
                if (evt.moved !== undefined) { // Перетаскивание элемента на самой панели не требуется и приводит к ошибке
                    return;
                }

                if (evt.added !== undefined) {
                    this.equipment.splice(evt.added.newIndex, 1);
                    this.selectedIndex = null;
                    if (this.tab == 0 && this.line.length == 0) {
                        this.deleteProfileLocal();
                        this.loadProfiles();
                    }
                } else {
                    this.equipment = [];

                    if (this.equipmentSrc.forEach !== undefined) {
                        this.equipmentSrc.forEach(element => {
                            this.equipment.push(element);
                        });
                    }
                }
            },

            /**
             * Скрытие интерфейсов конфигурирования оборудования
             */
            hideSettings () {
                this.$refs.BandSawSettings.visible     = false;
                this.$refs.CircularSawSettings.visible = false;
                this.$refs.FBSSettings.visible         = false;
                this.$refs.EdgeTrimmerSettings.visible = false;
                this.$refs.MultiSawSettings.visible    = false;
                this.$refs.ProfilingSettings.visible   = false;
                this.$refs.HorizontalSawSettings.visible = false;
            },

            /**
             * Отслеживание добавления оборудования на линию
             */
            addToLineEvt (evt) {
                this.$debug.log(evt);
                /*
                if (evt.type !== undefined && evt.type == "add") {
                    this.lineChanged = true;
                    this.$debug.log("evt.added");
                }
                */
            },

            /**
             * Отслеживание изменения порядка оборудования на линии
             */
            lineEvt (evt) {
                //this.$debug.log(evt);
                /*
                if (evt.added !== undefined) {
                    this.lineChanged = true;
                }
                */
                if (evt.moved !== undefined) {
                    this.selectedIndex = evt.moved.newIndex;
                    //this.lineChanged = true;
                }
                this.lineChanged = true;
                this.saveProfileLocal();
            },

            /**
             * Загрузка конфигураций доступного оборудования
             */
            loadEquipment () {
                this.loading.equipment = true;

                this.axios.get(`${this.$config.apiURL}equipment/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let equipmentInfo = response.data.equipment;

                            this.equipment    = [];
                            this.equipmentSrc = [];

                            equipmentInfo.forEach((item) => {
                                this.equipment.push({
                                    id:        item.id,
                                    //uid:       component.equipmentId++,
                                    name:      item.Name,
                                    shortName: item.ShortName,
                                    image:     "/img/equipment/" + item.Image,
                                    data:      JSON.parse(item.OptionsJSON)
                                });

                                this.equipmentSrc = Object.assign({}, this.equipment);
                            });
                        }

                        this.loading.equipment = false;
                    })
                    .catch(error => {
                        this.loading.equipment = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentData"));
                        }
                    });
            },

            /**
             * Загрузка текущего профиля
             */
            loadProfile () {
                if (this.tab == 0) {
                    this.line = [];

                    this.profile = {
                        data: "",
                        id: 0,
                        name: this.$t("newProfile")
                    }
                } else {
                    this.profile = this.profiles[this.tab];

                    this.line = this.profile && this.profile.data //!== null
                        ? JSON.parse(this.profile.data)
                        : [];
                    this.isLiveCutScheme = (this.line[1] !== undefined
                                            && this.line[1].data !== null
                                            && this.line[1].data.isLiveCutScheme !== undefined
                                            && this.line[1].data.isLiveCutScheme.val == 1) ? true : false;
                }
                this.lineChanged = false;
            },

            /**
             * Загрузка профилей линий
             */
            loadProfiles () {
                this.loading.profiles = true;
                this.isLiveCutScheme = false;

                this.axios.get(`${this.$config.apiURL}lines/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let profilesInfo = response.data.lines

                            this.profiles = [
                                {
                                    id:   0,
                                    name: this.$t("newProfile"),
                                    data: null
                                }
                            ];

                            if (profilesInfo.length == 0) {
                                this.tab = 0;
                            }

                            if (this.tab == 0) {
                                this.profile = {
                                    id:   0,
                                    name: this.$t("newProfile"),
                                    data: null
                                };

                                this.profileId = 0;
                            }

                            profilesInfo.forEach((item) => {
                                this.profiles.push({
                                    id:   item.id,
                                    name: item.Name,
                                    data: item.DataJSON
                                });
                            });

                            this.line          = [];
                            this.selectedIndex = null;

                            this.deleteProfileLocal();
                            this.loadProfile();
                        }

                        this.$refs.BandSawSettings.visible     = false;
                        this.$refs.CircularSawSettings.visible = false;
                        this.$refs.FBSSettings.visible         = false;
                        this.$refs.EdgeTrimmerSettings.visible = false;
                        this.$refs.MultiSawSettings.visible    = false;
                        this.$refs.ProfilingSettings.visible   = false;
                        this.$refs.HorizontalSawSettings.visible = false;

                        this.$refs.BandSawSettings.changed     = false;
                        this.$refs.CircularSawSettings.changed = false;
                        this.$refs.FBSSettings.changed         = false;
                        this.$refs.EdgeTrimmerSettings.changed = false;
                        this.$refs.MultiSawSettings.changed    = false;
                        this.$refs.ProfilingSettings.changed   = false;
                        this.$refs.HorizontalSawSettings.changed = false;

                        this.loading.profiles = false;
                    })
                    .catch(error => {
                        this.loading.profiles = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadProfiles") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadProfiles") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadProfiles"));
                        }
                    });
            },

            /**
             * Возвращает истину если передаваемый параметр - пустой объект
             *
             * @param {object} obj Проверяемый объект
             */
            /*
            objectIsEmpty (obj) {
                return obj == null || (
                        obj // 👈 null and undefined check
                        && Object.keys(obj).length === 0
                        && Object.getPrototypeOf(obj) === Object.prototype
                    );
            },
            */

            /**
             * Сохранение профиля с новым названием
             *
             * @param {string} profileName Название профиля
             */
            saveProfileAs (profileName) {
                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}lines/`,
                    data: {
                        name:     profileName,
                        dataJSON: this.profile.data ? this.profile.data : JSON.stringify(this.line)
                    },
                    withCredentials: true
                }).then(response => {
                    if (response.status == 200 ) {
                        if (response.data.status == "attention" && response.data.message == "subscriptionLimitReached") {
                            this.showMessageBox(this.$t("attention"), this.$t("saveProfilesLimitReachedMessage"));
                        } else if (response.data.status == "attention") {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile"));
                        } else {
                            this.alertType   = "success";
                            this.alert       = this.$t("profileSaved");
                            this.dataUpdated = true;
                            this.lineChanged = false;
                            this.deleteProfileLocal();
                            this.loadProfiles();
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки "Сохранить профиль как"
             */
            saveProfileAsClick () {
                if (this.line.length < 1) {
                    this.showMessageBox(this.$t("error"), this.$t("emptyLineErrorMessage"));
                } else {
                    this.$refs.TextInputDialog.title     = this.$t("saveProfile");
                    this.$refs.TextInputDialog.hintText  = this.$t("profileName");
                    this.$refs.TextInputDialog.textInput = this.profile.name == this.$t("newProfile") ? `${this.$t("newProfile")} ${this.profiles.length + 1}` : this.profile.name;
                    this.$refs.TextInputDialog.dialog    = true;
                }
            },

            /**
             * Обработчик нажатия кнопки сохранения профиля
             */
            saveProfileClick () {
                this.isRenameRequest = false;
                if (this.profile.id == 0) {
                    this.saveProfileAsClick();
                } else {
                    this.profile.data = JSON.stringify(this.line);
                    this.axios({
                        method: "patch",
                        url: `${this.$config.apiURL}lines/${this.profile.id}/`,
                        data: {
                            name:     this.profile.name,
                            dataJSON: this.profile.data,
                            deleted:  false
                        },
                        withCredentials: true
                    }).then(() => {
                        this.alertType   = "success";
                        this.alert       = this.$t("profileSaved");
                        this.dataUpdated = true;
                        this.lineChanged = false;

                        this.deleteProfileLocal();
                    }).catch(error => {
                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveProfile"));
                        }
                    });
                }
            },

            /**
             * Сохранение текущего профиля в localStorage
             */
            saveProfileLocal () {
                localStorage.setItem("line" + this.tab, JSON.stringify(this.line));
            },

            /**
             * Активация оборудования и отображение его настроек
             *
             * @param {object} item  Выбранное оборудование
             * @param {number} index Индекс выбранного оборудования
             */
            selectEquipment (item, index) {
                this.selectedIndex = index;
                this.line.forEach((eItem) => {
                    eItem.selected = false;
                })

                item.selected = true;

                this.showEquipmentSettings(item);
            },

            /**
             * Установка параметров ленточной пилы
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setBandSawSettings (item, show = true) {
                this.$refs.BandSawSettings.disableWatch = true;

                this.$refs.BandSawSettings.kerf.min = item.data.kerf.min
                    ? item.data.kerf.min
                    : 0;
                this.$refs.BandSawSettings.kerf.max = item.data.kerf.max
                    ? item.data.kerf.max
                    : 20;
                this.$refs.BandSawSettings.kerf.val = item.data.kerf.val
                    ? item.data.kerf.val
                    : this.$refs.BandSawSettings.kerf.min;

                this.$refs.BandSawSettings.trimSideBoards = item.data.trimSideBoards.val
                    ? item.data.trimSideBoards.val == 1
                    : false;
                this.$refs.BandSawSettings.maxSideBoardsAmount.min = item.data.sideBoardsMax.min
                    ? item.data.sideBoardsMax.min
                    : 0;
                this.$refs.BandSawSettings.maxSideBoardsAmount.max = item.data.sideBoardsMax.max
                    ? item.data.sideBoardsMax.max
                    : 12;
                this.$refs.BandSawSettings.maxSideBoardsAmount.val = item.data.sideBoardsMax.val
                    ? item.data.sideBoardsMax.val
                    : this.$refs.ProfilingSettings.maxSideBoardsAmount.min;
                this.$refs.BandSawSettings.splitSides = item.data.splitSides.val
                    ? item.data.splitSides.val == 1
                    : false;

                this.$refs.BandSawSettings.trimCentralPattern = item.data.trimCentralPattern.val
                    ? item.data.trimCentralPattern.val == 1
                    : false;
                this.$refs.BandSawSettings.splitCentral = item.data.splitCentral.val
                    ? item.data.splitCentral.val == 1
                    : false;

                this.$refs.BandSawSettings.disableWatch = false;
                this.$refs.BandSawSettings.visible      = show;
            },

            /**
             * Установка параметров круглопильного станка
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setCircularSawSettings (item, show = true) {
                this.$refs.CircularSawSettings.disableWatch = true;

                this.$refs.CircularSawSettings.maxAmount.min = item.data.maxAmount.min
                    ? item.data.maxAmount.min
                    : 0;
                this.$refs.CircularSawSettings.maxAmount.max = item.data.maxAmount.max
                    ? item.data.maxAmount.max
                    : 20;
                this.$refs.CircularSawSettings.maxAmount.val = item.data.maxAmount.val
                    ? item.data.maxAmount.val
                    : this.$refs.CircularSawSettings.maxAmount.min;

                this.$refs.CircularSawSettings.kerf.min = item.data.kerf.min
                    ? item.data.kerf.min
                    : 0;
                this.$refs.CircularSawSettings.kerf.max = item.data.kerf.max
                    ? item.data.kerf.max
                    : 20;
                this.$refs.CircularSawSettings.kerf.val = item.data.kerf.val
                    ? item.data.kerf.val
                    : this.$refs.CircularSawSettings.kerf.min;

                this.$refs.CircularSawSettings.kerfExt.min = item.data.kerfExt.min
                    ? item.data.kerfExt.min
                    : 0;
                this.$refs.CircularSawSettings.kerfExt.max = item.data.kerfExt.max
                    ? item.data.kerfExt.max
                    : 20;
                this.$refs.CircularSawSettings.kerfExt.val = item.data.kerfExt.val
                    ? item.data.kerfExt.val
                    : this.$refs.CircularSawSettings.kerfExt.min;

                this.$refs.CircularSawSettings.halfCantEnabled = item.data.halfCantEnabled.val == 1;

                this.$refs.CircularSawSettings.halfCant.min = item.data.halfCant.min
                    ? item.data.halfCant.min
                    : 0;
                this.$refs.CircularSawSettings.halfCant.max = item.data.halfCant.max
                    ? item.data.halfCant.max
                    : 20;
                this.$refs.CircularSawSettings.halfCant.val = item.data.halfCant.val
                    ? item.data.halfCant.val
                    : item.data.halfCant.min;

                this.$refs.CircularSawSettings.similarSizeBoards = item.data.similarSizeBoards.val == 1;

                this.$refs.CircularSawSettings.thicknessByKerf = item.data.sawsThicknessByKerfHeight.val == 1;

                this.$refs.CircularSawSettings.useEdgeTrimmer = item.data.useEdgeTrimmer.val
                    ? item.data.useEdgeTrimmer.val == 1
                    : false;

                this.$refs.CircularSawSettings.edgeTrimmerMaxAmount.min = item.data.edgeTrimmerMaxAmount.min
                    ? item.data.edgeTrimmerMaxAmount.min
                    : 0;
                this.$refs.CircularSawSettings.edgeTrimmerMaxAmount.max = item.data.edgeTrimmerMaxAmount.max
                    ? item.data.edgeTrimmerMaxAmount.max
                    : 12;
                this.$refs.CircularSawSettings.edgeTrimmerMaxAmount.val = item.data.edgeTrimmerMaxAmount.val
                    ? item.data.edgeTrimmerMaxAmount.val
                    : 2;

                this.$refs.CircularSawSettings.edgeTrimmerKerf.min = item.data.edgeTrimmerKerf.min
                    ? item.data.edgeTrimmerKerf.min
                    : 0;
                this.$refs.CircularSawSettings.edgeTrimmerKerf.max = item.data.edgeTrimmerKerf.max
                    ? item.data.edgeTrimmerKerf.max
                    : 10;
                this.$refs.CircularSawSettings.edgeTrimmerKerf.val = item.data.edgeTrimmerKerf.val
                    ? item.data.edgeTrimmerKerf.val
                    : 5;

                this.$refs.CircularSawSettings.useCleanSaws = item.data.useCleanSaws.val
                    ? item.data.useCleanSaws.val == 1
                    : false;
                this.$refs.CircularSawSettings.cleanKerf.min = item.data.cleanKerf.min
                    ? item.data.cleanKerf.min
                    : 0;
                this.$refs.CircularSawSettings.cleanKerf.max = item.data.cleanKerf.max
                    ? item.data.cleanKerf.max
                    : 10;
                this.$refs.CircularSawSettings.cleanKerf.val = item.data.cleanKerf.val
                    ? item.data.cleanKerf.val
                    : 5;

                this.$refs.CircularSawSettings.disableWatch = false;
                this.$refs.CircularSawSettings.visible      = show;
            },

            /**
             * Установка параметров кромкообрезного станка
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setEdgeTrimmerSettings (item, show = true) {
                this.$refs.EdgeTrimmerSettings.disableWatch = true;

                this.$refs.EdgeTrimmerSettings.maxAmount.min = item.data.maxAmount.min
                    ? item.data.maxAmount.min
                    : 0;
                this.$refs.EdgeTrimmerSettings.maxAmount.max = item.data.maxAmount.max
                    ? item.data.maxAmount.max
                    : 20;
                this.$refs.EdgeTrimmerSettings.maxAmount.val = item.data.maxAmount.val
                    ? item.data.maxAmount.val
                    : this.$refs.EdgeTrimmerSettings.maxAmount.min;

                this.$refs.EdgeTrimmerSettings.kerf.min = item.data.kerf.min
                    ? item.data.kerf.min
                    : 0;
                this.$refs.EdgeTrimmerSettings.kerf.max = item.data.kerf.max
                    ? item.data.kerf.max
                    : 10;
                this.$refs.EdgeTrimmerSettings.kerf.val = item.data.kerf.val
                    ? item.data.kerf.val
                    : this.$refs.EdgeTrimmerSettings.kerf.min;

                this.$refs.EdgeTrimmerSettings.optimizeByWidth = item.data.optimizationByWidth.val
                    ? item.data.optimizationByWidth.val == 1
                    : false;

                this.$refs.EdgeTrimmerSettings.sameWidth = item.data.sameWidth
                    ? item.data.sameWidth == 1
                    : false;

                this.$refs.EdgeTrimmerSettings.disableWatch = false;
                this.$refs.EdgeTrimmerSettings.visible      = show;
            },

            /**
             * Установка параметров ФБС
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setFBSSettings (item, show = true) {
                this.$refs.FBSSettings.disableWatch = true;

                this.$refs.FBSSettings.maxCantThickness.min = item.data.maxCantThickness.min
                    ? item.data.maxCantThickness.min
                    : 0;
                this.$refs.FBSSettings.maxCantThickness.max = item.data.maxCantThickness.max
                    ? item.data.maxCantThickness.max
                    : 0;
                this.$refs.FBSSettings.maxCantThickness.val = item.data.maxCantThickness.val
                    ? item.data.maxCantThickness.val
                    : this.$refs.FBSSettings.maxCantThickness.min;

                this.$refs.FBSSettings.maxCuttingDepth.min = item.data.maxCuttingDepth.min
                    ? item.data.maxCuttingDepth.min
                    : 0;
                this.$refs.FBSSettings.maxCuttingDepth.max = item.data.maxCuttingDepth.max
                    ? item.data.maxCuttingDepth.max
                    : 0;
                this.$refs.FBSSettings.maxCuttingDepth.val = item.data.maxCuttingDepth.val
                    ? item.data.maxCuttingDepth.val
                    : this.$refs.FBSSettings.maxCuttingDepth.min;

                this.$refs.FBSSettings.minTopSideBoardsWidth.min = item.data.minTopSideBoardsWidth.min
                    ? item.data.minTopSideBoardsWidth.min
                    : 0;
                this.$refs.FBSSettings.minTopSideBoardsWidth.max = item.data.minTopSideBoardsWidth.max
                    ? item.data.minTopSideBoardsWidth.max
                    : 0;
                this.$refs.FBSSettings.minTopSideBoardsWidth.val = item.data.minTopSideBoardsWidth.val
                    ? item.data.minTopSideBoardsWidth.val
                    : this.$refs.FBSSettings.minTopSideBoardsWidth.min;

                this.$refs.FBSSettings.useCleanSaws = item.data.useCleanSaws.val
                    ? item.data.useCleanSaws.val == 1
                    : false;
                this.$refs.FBSSettings.cleanKerf.min = item.data.cleanKerf.min
                    ? item.data.cleanKerf.min
                    : 0;
                this.$refs.FBSSettings.cleanKerf.max = item.data.cleanKerf.max
                    ? item.data.cleanKerf.max
                    : 10;
                this.$refs.FBSSettings.cleanKerf.val = item.data.cleanKerf.val
                    ? item.data.cleanKerf.val
                    : 5;

                this.$refs.FBSSettings.disableWatch = false;
                this.$refs.FBSSettings.visible      = show;
            },

            /**
             * Установка параметров многопильного станка
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setMultiSawSettings (item, show = true) {
                this.$refs.MultiSawSettings.disableWatch = true;

                this.$refs.MultiSawSettings.maxAmount.min = item.data.maxAmount.min
                    ? item.data.maxAmount.min
                    : 0;
                this.$refs.MultiSawSettings.maxAmount.max = item.data.maxAmount.max
                    ? item.data.maxAmount.max
                    : 12;
                this.$refs.MultiSawSettings.maxAmount.val = item.data.maxAmount.val
                    ? item.data.maxAmount.val
                    : this.$refs.MultiSawSettings.maxAmount.min;

                this.$refs.MultiSawSettings.kerf.min = item.data.kerf.min
                    ? item.data.kerf.min
                    : 0;
                this.$refs.MultiSawSettings.kerf.max = item.data.kerf.max
                    ? item.data.kerf.max
                    : 10;
                this.$refs.MultiSawSettings.kerf.val = item.data.kerf.val
                    ? item.data.kerf.val
                    : this.$refs.MultiSawSettings.kerf.min;

                this.$refs.MultiSawSettings.patternType = item.data.patternType.val
                    ? Number.parseInt(item.data.patternType.val)
                    : 1;

                this.$refs.MultiSawSettings.sawWidthDep = item.data.sawWidthDependOnKerf.val
                    ? item.data.sawWidthDependOnKerf.val == 1
                    : false;

                this.$refs.MultiSawSettings.useEdgeTrimmer = item.data.useEdgeTrimmer.val
                    ? item.data.useEdgeTrimmer.val == 1
                    : false;
                this.$refs.MultiSawSettings.splitCentralBoards = item.data.splitCentralBoards.val
                    ? item.data.splitCentralBoards.val == 1
                    : false;

                this.$refs.MultiSawSettings.edgeTrimmerMaxAmount.min = item.data.edgeTrimmerMaxAmount.min
                    ? item.data.edgeTrimmerMaxAmount.min
                    : 0;
                this.$refs.MultiSawSettings.edgeTrimmerMaxAmount.max = item.data.edgeTrimmerMaxAmount.max
                    ? item.data.edgeTrimmerMaxAmount.max
                    : 12;
                this.$refs.MultiSawSettings.edgeTrimmerMaxAmount.val = item.data.edgeTrimmerMaxAmount.val
                    ? item.data.edgeTrimmerMaxAmount.val
                    : 2;

                this.$refs.MultiSawSettings.edgeTrimmerKerf.min = item.data.edgeTrimmerKerf.min
                    ? item.data.edgeTrimmerKerf.min
                    : 0;
                this.$refs.MultiSawSettings.edgeTrimmerKerf.max = item.data.edgeTrimmerKerf.max
                    ? item.data.edgeTrimmerKerf.max
                    : 10;
                this.$refs.MultiSawSettings.edgeTrimmerKerf.val = item.data.edgeTrimmerKerf.val
                    ? item.data.edgeTrimmerKerf.val
                    : 5;

                this.$refs.MultiSawSettings.useCleanSaws = item.data.useCleanSaws.val
                    ? item.data.useCleanSaws.val == 1
                    : false;
                this.$refs.MultiSawSettings.cleanKerf.min = item.data.cleanKerf.min
                    ? item.data.cleanKerf.min
                    : 0;
                this.$refs.MultiSawSettings.cleanKerf.max = item.data.cleanKerf.max
                    ? item.data.cleanKerf.max
                    : 10;
                this.$refs.MultiSawSettings.cleanKerf.val = item.data.cleanKerf.val
                    ? item.data.cleanKerf.val
                    : 5;

                this.$refs.MultiSawSettings.disableWatch = false;
                this.$refs.MultiSawSettings.visible      = show;
            },

            /**
             * Установка параметров профилирующего станка
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setProfilingSettings (item, show = true) {
                this.$refs.ProfilingSettings.disableWatch = true;

                this.$refs.ProfilingSettings.maxDepth.min = item.data.maxProfilingDepth.min
                    ? item.data.maxProfilingDepth.min
                    : 0;
                this.$refs.ProfilingSettings.maxDepth.max = item.data.maxProfilingDepth.max
                    ? item.data.maxProfilingDepth.max
                    : 12;
                this.$refs.ProfilingSettings.maxDepth.val = item.data.maxProfilingDepth.val
                    ? item.data.maxProfilingDepth.val
                    : this.$refs.ProfilingSettings.maxDepth.min;

                this.$refs.ProfilingSettings.maxSideBoardsAmount.min = item.data.sideBoardsMax.min
                    ? item.data.sideBoardsMax.min
                    : 0;
                this.$refs.ProfilingSettings.maxSideBoardsAmount.max = item.data.sideBoardsMax.max
                    ? item.data.sideBoardsMax.max
                    : 12;
                this.$refs.ProfilingSettings.maxSideBoardsAmount.val = item.data.sideBoardsMax.val
                    ? item.data.sideBoardsMax.val
                    : this.$refs.ProfilingSettings.maxSideBoardsAmount.min;

                this.$refs.ProfilingSettings.centralBoardsMinTotalThickness.min = item.data.centralBoardsThicknessMin.min
                    ? item.data.centralBoardsThicknessMin.min
                    : 0;
                this.$refs.ProfilingSettings.centralBoardsMinTotalThickness.max = item.data.centralBoardsThicknessMin.max
                    ? item.data.centralBoardsThicknessMin.max
                    : 12;
                this.$refs.ProfilingSettings.centralBoardsMinTotalThickness.val = item.data.centralBoardsThicknessMin.val
                    ? item.data.centralBoardsThicknessMin.val
                    : this.$refs.ProfilingSettings.centralBoardsMinTotalThickness.min;

                this.$refs.ProfilingSettings.useCleanSaws = item.data.useCleanSaws.val
                    ? item.data.useCleanSaws.val == 1
                    : false;
                this.$refs.ProfilingSettings.cleanKerf.min = item.data.cleanKerf.min
                    ? item.data.cleanKerf.min
                    : 0;
                this.$refs.ProfilingSettings.cleanKerf.max = item.data.cleanKerf.max
                    ? item.data.cleanKerf.max
                    : 10;
                this.$refs.ProfilingSettings.cleanKerf.val = item.data.cleanKerf.val
                    ? item.data.cleanKerf.val
                    : 5;

                this.$refs.ProfilingSettings.disableWatch = false;
                this.$refs.ProfilingSettings.visible      = show;
            },

            /**
             * Установка параметров горизонтальной пилы
             *
             * @param {object}  item Параметры
             * @param {boolean} show Отобразить форму после задания параметров
             */
            setHorizontalSawSettings (item, show = true) {
                this.$refs.HorizontalSawSettings.disableWatch = true;

                this.$refs.HorizontalSawSettings.maxAmount.min = item.data.maxAmount.min
                    ? item.data.maxAmount.min
                    : 0;
                this.$refs.HorizontalSawSettings.maxAmount.max = item.data.maxAmount.max
                    ? item.data.maxAmount.max
                    : 20;
                this.$refs.HorizontalSawSettings.maxAmount.val = item.data.maxAmount.val
                    ? item.data.maxAmount.val
                    : this.$refs.HorizontalSawSettings.maxAmount.min;

                this.$refs.HorizontalSawSettings.kerf.min = item.data.kerf.min
                    ? item.data.kerf.min
                    : 0;
                this.$refs.HorizontalSawSettings.kerf.max = item.data.kerf.max
                    ? item.data.kerf.max
                    : 10;
                this.$refs.HorizontalSawSettings.kerf.val = item.data.kerf.val
                    ? item.data.kerf.val
                    : this.$refs.HorizontalSawSettings.kerf.min;

                this.$refs.HorizontalSawSettings.disableWatch = false;
                this.$refs.HorizontalSawSettings.visible      = show;
            },

            /**
             * Отображение интерфейса установки параметров
             *
             * @param {object} item Параметры
             */
            showEquipmentSettings (item) {
                this.hideSettings();

                if (item.data !== null) {
                    switch (item.data.type) {
                        case "bandSaw":
                            this.setBandSawSettings(item);
                            break;
                        case "circularSaw":
                            this.setCircularSawSettings(item);
                            break;
                        case "edgeTrimmer":
                            this.setEdgeTrimmerSettings(item);
                            break;
                        case "fbs":
                            this.setFBSSettings(item);
                            break;
                        case "multiSaw":
                            this.setMultiSawSettings(item);
                            break;
                        case "profiling":
                            this.setProfilingSettings(item);
                            break;
                        case "horizontalSaw":
                            this.setHorizontalSawSettings(item);
                    }
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                if (this.$refs.MessageBox === undefined) return;

                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    $hover-color: #1976d2
    $brd-radius: 15px

    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 176px)

    .line-card
        overflow-y: auto
        max-height: calc(50dvh - 110px)

    .equipment-item
        float: left
        width: 150px
        border: solid 1px transparent
        border-radius: $brd-radius
        >
            div
                height: 0
                text-overflow: hidden
                text-align: center
                border-radius: $brd-radius
                margin: 2px
            img
                height: 150px
        &:hover
            background-color: $hover-color
            >
                div
                    height: auto
                    text-overflow: hidden
                    text-align: center
                    margin: 2px
                    border-radius: $brd-radius
        .item-title
            font-size: 16px
            cursor: pointer

    .equipment-item-small
        float: left
        margin: 5px
        width: 102px
        height: 105px
        border: solid 1px transparent
        border-radius: 10px
        text-align: center
        overflow: hidden
        >
            div
                text-align: center
                margin: 2px
            img
                height: 65px
            .item-title
                font-size: 10px
                cursor: default
        &:hover
            box-shadow: 0 1px 2px rgba(0,0,0,0.5)
            transition: ease-in-out .25s

    .row-v
        min-height: 150px
        h3
            overflow: hidden
            text-overflow: ellipsis

    .line
        min-height: 150px
        :last-child::after
            display: none

    .selected
        background: radial-gradient(#e3f2fd, #bbdefb)

    .blockHead
        border: 0
        background-color: #ddd
        margin: 12px
        height: 150px
        display: inline-block
        position: relative
        &:after
            color: #ddd
            border-left: 20px solid
            border-top: 20px solid transparent
            border-bottom: 20px solid transparent
            display: inline-block
            content: ''
            position: absolute
            right: -20px
            top: 52px
        &.selected:after
            color: #c6e4fc

    .bottom-alert
        position: fixed
        bottom: 0
        left: 0
        width: 100%
        z-index: 9999

    .flex-card
        display: flex
        flex-direction: column

        .v-toolbar
            flex: 0

    .v-card--reveal
        align-items: center
        bottom: 0
        justify-content: center
        opacity: .85
        position: absolute
        width: 100%
        font-size: 12px

    .unsaved
        cursor: default

    .dev-num
        position: absolute
        z-index: +1
        color: #fff

    .dev-settings
        background: transparent !important
        position: absolute
        z-index: +1
        bottom: 2px
        left: 2px
        > i
            color: #777

    .dev-settings:hover
        background: $hover-color !important
        cursor: pointer
        > i
            color: #fff

    .equipment-item:hover
        .dev-settings,
        .dev-settings:hover
            > i
                color: #fff

    .dragArea
        &.content-centered
            max-width: 230px
            margin: auto
        &.fill-height
            height: calc(100vh - 275px)

    .pattern-container
        &-container
            box-sizing: border-box
            border: px solid #aaa
            display: flex
            padding: 0px
            width: 220px
            height: 220px
            margin: 0 auto
            justify-content: center
            align-items: center
        .label
            display: none
        .label
            display: none !important
</style>
